import React from "react";

import Connection from "./Connection";
import NewConnection from "./NewConnection";

import { PiMagnifyingGlass } from "react-icons/pi";
import {connect} from "react-redux";
import Record from "./Record";

const DiscoveredList = ({records, height}) => {

    /*data && data.sort(function(a, b){
        //if( (a.connected && b.connected) ) return a.uid > b.uid;
        //else if( (a.connected && !b.connected) ) return -1;
        //else if( (!a.connected && b.connected) ) return 1;
        //else return ( a.uid > b.uid  )

        return a.uid < b.uid ? -1 : 1
    });*/

    const rempty = records && records.length === 0 || records?.record //&&  records.record.length === 0 //&& records.filter(it => !it.connected && !it.deleted).length === 0

    const _minWidth = 200
    const _minHeight = height
    const _maxHeight = _minHeight
    const _height = _minHeight

    return (
        <div key={'llll'}>

            <div className="list listHeader" key={'header_'} style={{
                minWidth: _minWidth,
            }}>
                <span key={'conx12'}><PiMagnifyingGlass/>&nbsp;Discovered</span>
            </div>

            <div key={''} className="list listBody" style={{
                minWidth: _minWidth,

                height:_height,
                minHeight: _minHeight,
                maxHeight: _maxHeight,
                overflowY: 'auto',
            }}>
                {records?.map(it =>
                    <Record key={it.uid} uid={it.uid} data={it} show={true}/>
                )}
                <NewConnection key={'newcon'}/>
            </div>
        </div>
    )

}

/*
<div key={'unconn_'} className="list listBody" style={{
                minWidth: _minWidth,
            }}>
                <NewConnection key={'newcon_inner'}/>
            </div>
 */

function mapStateToProps(state, other) {

    return {records: state.bidib.data.record.filter(it => !it.deleted && !it.connected && it.uid), height: window.innerHeight - 150, nodes: state.bidib.data.node}
}

export default connect(mapStateToProps)(DiscoveredList)